import React, { useState } from 'react';
import { basicUiApi, BasicUiData } from '../../services/basicUiApi';
import { applyBasicUiSettings } from '../../utils/uiUtils';

const BasicUiTest: React.FC = () => {
  const [uiData, setUiData] = useState<BasicUiData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleLoadBasicUi = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const data = await basicUiApi.getBasicUi();
      
      if (!data) {
        setError('기본 UI 설정을 찾을 수 없습니다. (404 Not Found)');
        /// console.warn('기본 UI 설정이 없습니다.');
        return;
      }
      
      setUiData(data);
      applyBasicUiSettings(data);
      /// console.log('기본 UI 데이터 로드 성공:', data);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : '알 수 없는 오류가 발생했습니다.';
      setError(errorMessage);
      /// console.error('기본 UI 데이터 로드 실패:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>기본 UI 설정 테스트</h1>
      
      <button 
        onClick={handleLoadBasicUi}
        disabled={loading}
        style={{
          padding: '10px 20px',
          backgroundColor: '#448181',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: loading ? 'not-allowed' : 'pointer',
          marginBottom: '20px'
        }}
      >
        {loading ? '로딩 중...' : '기본 UI 설정 로드'}
      </button>

      {error && (
        <div style={{
          padding: '10px',
          backgroundColor: '#fee',
          border: '1px solid #fcc',
          borderRadius: '5px',
          color: '#c33',
          marginBottom: '20px'
        }}>
          <strong>오류:</strong> {error}
        </div>
      )}

      {uiData && (
        <div style={{
          padding: '20px',
          backgroundColor: '#f9f9f9',
          border: '1px solid #ddd',
          borderRadius: '5px'
        }}>
          <h2>로드된 UI 설정</h2>
          <div style={{ marginBottom: '10px' }}>
            <strong>ID:</strong> {uiData.id}
          </div>
          <div style={{ marginBottom: '10px' }}>
            <strong>웹사이트 이름:</strong> {uiData.web_name}
          </div>
          <div style={{ marginBottom: '10px' }}>
            <strong>파비콘 URL:</strong> 
            <br />
            <a href={uiData.favicon_url} target="_blank" rel="noopener noreferrer">
              {uiData.favicon_url}
            </a>
          </div>
          <div style={{ marginBottom: '10px' }}>
            <strong>헤더 로고 URL:</strong>
            <br />
            <a href={uiData.header_logo_url} target="_blank" rel="noopener noreferrer">
              {uiData.header_logo_url}
            </a>
          </div>
          <div style={{ marginBottom: '10px' }}>
            <strong>관리자 프로필 이미지 URL:</strong>
            <br />
            <a href={uiData.admin_profile_image_url} target="_blank" rel="noopener noreferrer">
              {uiData.admin_profile_image_url}
            </a>
          </div>
          
          <div style={{ marginTop: '20px' }}>
            <h3>미리보기</h3>
            <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
              <div>
                <strong>파비콘:</strong>
                <br />
                <img 
                  src={uiData.favicon_url} 
                  alt="Favicon" 
                  style={{ width: '32px', height: '32px', marginTop: '5px' }}
                  onError={(e) => {
                    e.currentTarget.style.display = 'none';
                  }}
                />
              </div>
              <div>
                <strong>헤더 로고:</strong>
                <br />
                <img 
                  src={uiData.header_logo_url} 
                  alt="Header Logo" 
                  style={{ maxWidth: '200px', maxHeight: '50px', marginTop: '5px' }}
                  onError={(e) => {
                    e.currentTarget.style.display = 'none';
                  }}
                />
              </div>
              <div>
                <strong>관리자 프로필:</strong>
                <br />
                <img 
                  src={uiData.admin_profile_image_url} 
                  alt="Admin Profile" 
                  style={{ width: '50px', height: '50px', borderRadius: '50%', marginTop: '5px' }}
                  onError={(e) => {
                    e.currentTarget.style.display = 'none';
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      <div style={{ marginTop: '20px', fontSize: '14px', color: '#666' }}>
        <p><strong>참고:</strong></p>
        <ul>
          <li>이 버튼을 클릭하면 API에서 기본 UI 설정을 로드합니다.</li>
          <li>성공적으로 로드되면 브라우저의 파비콘과 제목이 자동으로 변경됩니다.</li>
          <li>개발자 도구의 콘솔에서 자세한 로그를 확인할 수 있습니다.</li>
        </ul>
      </div>
    </div>
  );
};

export default BasicUiTest;
